import React from 'react'

import { NavLink, useParams } from 'react-router-dom'

import { List, ListItem, ListItemText, useTheme } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'
import { isNonProductionEnvironment } from '../../utils/environment'
import useCurrentUser from '../../hooks/useCurrentUser'

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const AdminNavLinks = (props) => {
	const { selectedFacility, location, selectedMarket } = props
	const { isSuperUser } = useCurrentUser()

	const classes = useStyles()
	const params = useParams()

	if ((location.pathname.includes('home') || location.pathname.includes('push')) && selectedMarket)
		return (
			<List className={classes.defaultNav}>
				<ListItem
					component={NavLink}
					className={classes.listItem}
					to={`/globalAdmin/markets/${selectedMarket._id}/home`}
					selected={location.pathname.includes('home')}>
					<ListItemText primary="Edit Market" />
				</ListItem>
				{/*<ListItem
					component={NavLink}
					className={classes.listItem}
					to={`/globalAdmin/markets/${selectedMarket._id}/push`}
					selected={location.pathname.includes('push')}>
					<ListItemText primary="Push Notifications" />
		</ListItem>*/}
			</List>
		)

	return (
		<List className={classes.defaultNav}>
			<ListItem component={NavLink} className={classes.listItem} to={`/globalAdmin/markets`}>
				<ListItemText primary="Markets" />
			</ListItem>
			{isSuperUser ? (
				<ListItem component={NavLink} className={classes.listItem} to={`/globalAdmin/promos`}>
					<ListItemText primary="Promotions" />
				</ListItem>
			) : null}
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/globalAdmin/appUpdate`}
				selected={location.pathname.includes('appUpdate')}>
				<ListItemText primary="App Update" />
			</ListItem>
			{isNonProductionEnvironment() && (
				<ListItem component={NavLink} className={classes.listItem} to={`/globalAdmin/run-payments`}>
					<ListItemText primary="Run Payments" />
				</ListItem>
			)}
		</List>
	)
}

export default AdminNavLinks
